import css from './Group.module.scss'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { ITicket, ITicketGroup } from 'meta/backendControlled/structure/ticket'
import { RouteParams } from 'meta/routes'
import { useAppDispatch } from 'store'
import { CheckoutActions } from 'store/pages/checkout'

import { useShowAll } from 'components/BackendControlled/Component/EventTicket/hooks/useShowAll'
import Ticket from 'components/BackendControlled/Component/EventTicket/Ticket'
import { Grid, GridColumn, GridContainer } from 'components/Layout/Grid'
import ShowMoreBox from 'components/Structure/ShowMoreBox'

import GroupMap from '../GroupMap'

interface IProps {
  ticketsData: ITicket[]
  groupData: ITicketGroup
}

const Group: React.FC<IProps> = (props) => {
  const { groupData, ticketsData } = props

  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { codeUrl } = useParams<RouteParams['Event']>() as RouteParams['Event']

  const gridRef = useRef<HTMLDivElement>(null)

  const { showAll, toggleShowMore } = useShowAll({ gridRef })

  const openCheckout = (initialTypeTicketId?: number) => {
    dispatch(CheckoutActions.init({ codeUrl, initialTypeTicketId }))
  }

  return (
    <GridContainer className={css.container}>
      <Grid ref={gridRef}>
        <GridColumn gridColumnEnd={17}>
          <h2>{groupData.name}</h2>
        </GridColumn>
      </Grid>

      {groupData?.cover?.url && (
        <Grid>
          <GridColumn gridColumnEnd={17}>
            <GroupMap insideCheckout={false} bgImageUrl={groupData.cover.url} />
          </GridColumn>
        </Grid>
      )}

      <div className={css.tickets}>
        {ticketsData
          .filter((x: ITicket) => groupData.typeTicketIds.includes(x.id))
          .map((elem, key) => {
            return <Ticket callback={openCheckout} isGroupTicket key={key} data={elem} />
          })}
      </div>

      {groupData.typeTicketIds.length > 4 && (
        <div className={showAll ? css.showLess : css.showMore}>
          <ShowMoreBox
            toggleCallback={toggleShowMore}
            showMoreText={String(t('checkout:show_all'))}
            showLessText={String(t('checkout:show_less'))}
            showAll={showAll}
          />
        </div>
      )}
    </GridContainer>
  )
}

export default Group
